import React from 'react';
import TalentsCarousel from 'components/TalentsCarousel';
import { useDispatch, useSelector } from 'react-redux';
import { GetRegion } from 'constants.js';
import { selectTalentContent } from '../../selectors/vcard.selector';
import './style.scss';
import { useNavigate } from 'react-router-dom';
import { getRegion } from '../../../../utils/Region';
import { store } from '../../../../store';
import { setTalentInfoFromVcard } from '../../../NewSearchPage/redux/actions/talentFromVcardActions';
import { clearTalentFilterInfo } from 'containers/NewSearchTalentPage/Redux/actions/talentResultAction';

const mapTalents = info => {
  const talents = info?.map(role =>
      role?.talents?.map(talent => ({
        first_name: talent?.first_name,
        last_name: talent?.last_name,
        name: `${talent?.first_name} ${talent?.last_name}`,
        id: talent?.id,
        image: talent?.image,
        type: role?.role_name,
        provider: role?.provider,
      })),
    )
    .reduce((acc, talent) => acc.concat(talent), []);

  return talents;
};

const TalensSection = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const infoTalents = useSelector(selectTalentContent);
  const translations = useSelector(state => state.translations);

  if (!infoTalents) return null;
  const roles = infoTalents[infoTalents.node];
  const talents = mapTalents(roles);

  const onClick = (talentId, talents) => {
    const talent = talents.find(tal => tal.id === talentId);
    dispatch(clearTalentFilterInfo());
    dispatch(setTalentInfoFromVcard(talent));
    navigate(`/${getRegion()}/talent/${talentId}?name=${encodeURIComponent(talent?.name)}`);
  };

  return (
    <div>
      <TalentsCarousel
        title={translations.vcard_ribbon_talents_label}
        talents={talents}
        onTalentClick={talentId => onClick(talentId, talents, navigate)}
      />
    </div>
  );
};

export default TalensSection;
